<template>
  <div class="aboutUs-container">
    <SectionTop :id="1" />
    <div class="about-img-wrapper">
      <img src="@/assets/img/home/inSarubiamaru.jpg" alt="さるびあ丸の中の三人">
    </div>
    <div class="about-desc-wrapper scroll-animation" v-scroll-animation>
      <p>
        深い呼吸を忘れ、チリチリと息苦しい詰まりを胸に感じながらその日その日をなんとかこなし、疲労している。<br>
        私たちは伊豆大島に来ていた。
        流れていたのは、ノイズが溶けて消えたひとつの純粋な時間。いい時間だった。帰ってからもしばらく続いた。
        一緒に行った人とこれを共有するから、捉えどころのない感覚に輪郭ができて喜びに変えられる。
      </p>
      <p>
        その感覚は普段、言葉や理性が表面を覆う脳の奥底に息をひそめているが、手足と声を震わすものの力を借りて姿を現し、わたしたちを集中と俯瞰が共存する世界に引き込む。
        「二つの世界の呼応と調和」を実践できる方法の一つは、友達と一緒に伊豆大島で釣りをすることだった。
      </p>
      <p>
        このサイトのタイトルである「こころにゼロをとりもどせ」 。
        日々の中で意識が精彩を欠いたことにしっかりと気が付き、澄み切った洞察力や美しいものを感じたままに表現できる直感力をよみがえらせよう、という意味を込めている。
      </p>
    </div>
    <ViewMore :id="1" Class="view-more-wrapper" />
  </div>
</template>

<script>
import SectionTop from '@/features/home/components/SectionTop.vue';
import ViewMore from '@/features/home/components/ViewMore.vue';

export default {
  components: {
    SectionTop,
    ViewMore,
  },
};
</script>

<style scoped>
.aboutUs-container {
  position: relative;
  height : auto;
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.about-img-wrapper {
  position: relative;
  width: 100%;
  margin-top: 60px;
  display: flex;
  justify-content: center;
}

.about-img-wrapper img {
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.about-desc-wrapper {
  position: relative;
  height: auto;
  margin-top: 100px;
  width: 75%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  gap: 0rem;
}

.about-desc-wrapper p {
  font-family: "ShipporiMincho";
  color: #493c33;
  font-size: 15px;
  line-height: 1.8rem;
}

.about-desc-wrapper span {
  color: #69b1a9;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {
  .about-desc-wrapper p {
    font-size: 12px;
  }
}

@media screen and (max-width: 570px) {
  .about-desc-wrapper {
  width: 90%;
  }
  .about-desc-wrapper p {
    font-size: 12px;
  }
}
</style>